import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import { CONSTANT } from './constants';
import Cookies from 'js-cookie';
import { fetchIPAddress } from './helpers';


export const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const [golbalClientDetails, setGlobalClientDetails] = useState(null);
  
  const [loading, setLoading] = useState(true);

  const [layerItemIds, setLayerItemIds] = useState({});
  const [layerparam, setLayerParam ] = useState({});
  const [client_code, setClientCode] = useState();
  const [category, setCategory] = useState('Ring Builder');
  const [filterOption, setFilterOption] = useState();
  const [selectedItemId, setSelectedItemId] = useState({});
  const [accessToken,setAccessToken] = useState();
  const [tokenId,setTokenId] = useState();
  const [flags,setFlags] = useState();
  const [esterllaFlag,setEsterllaFlag] = useState(false);
  // Which flow the user started with ('diamond' or 'setting') — set once when they
  // pick a starting path (RingBanner) or pre-set via window.Builder_Data.direct, and
  // read downstream by dataLayer events (preview, schedule appointment, private showing).
  const [builderType, setBuilderType] = useState(window?.Builder_Data?.direct || '');

  const getCookieOrDefault = (key, defaultValue = {}) => {
    try {
      const cookieValue = Cookies.get(key); // Retrieve the cookie
      if (cookieValue) {
        return JSON.parse(cookieValue); // Parse and return the cookie if it exists
      } else {
        return defaultValue; // Return the default value if the cookie doesn't exist
      }
    } catch (error) {
      console.error(`Error retrieving or parsing cookie "${key}":`, error);
      return defaultValue; // Return the default value in case of an error
    }
  };
  const [basket, setBasket] = useState(() => getCookieOrDefault('basket', {}));
  const [basketShopify, setBasketShopify] = useState({});

  // Function to update layer params
  // Function to update layer params
  const updateLayerParams = (layerCode, paramKey, paramValue) => {
    setLayerParam((prev) => {
    // Get the current layer or initialize it with an empty object if not found
    const currentLayer = prev[layerCode] || {};
      
      // Update the specific param for the layer
      const updatedLayer = {
        ...currentLayer,      // Preserve existing layer data
        [paramKey]: paramValue // Dynamically update the param
      };
      
      // Return the updated state with the modified layer
      return {
        ...prev,
        [layerCode]: updatedLayer // Update the specific layer with the new param
      };
    });
  };
  /*Updated the Selected the Item Id*/
  const updatedSelectedItemDetails = (ItemDetails) => {
    setSelectedItemId(ItemDetails);
  }
  /*Updated the Selected the Item Id*/

  /*Update the Layer wise item id*/
  const updateLayerItemId = (layerCode, itemId, stoneSelected = null) => {
    setLayerItemIds((prev) => {
        const currentLayer = prev[layerCode] || {}; // Default to an empty object if undefined
        // Only set stoneKey if stoneSelected is defined and Layer 2
        const stoneKey = layerCode === 'Layer 2' && stoneSelected != null ? `Stone-${stoneSelected}` : null;
        if (currentLayer?.Item_id !== itemId?.id || (stoneKey && currentLayer[stoneKey] !== itemId?.id)) {
            return {
                ...prev,
                [layerCode]: {
                    ...currentLayer,
                    ...(layerCode === 'Layer 1' && itemId !== '' ? { Item_id: itemId?.id } : {}),
                    ...(layerCode === 'Layer 1' && itemId !== '' ? { Item_idDetails: itemId } : {}),
                    ...(layerCode === 'Layer 1' && itemId !== '' && itemId?.glb_files !== '' ? { GlbFilePath: itemId?.glb_files } : {}),
                    ...(layerCode === 'Layer 2' && stoneKey !== '' ? { [stoneKey]: itemId?.id } : {})
                },
            };
        }
        return prev;
    });
  };
  /*Update the Layer wise item id*/

  useEffect(() => {
    // Fetch client details from the API
    const fetchClientDetails = async () => {
      try {
        const { category, account_no, token_id } = window?.Builder_Data || {};
        setClientCode(account_no);
        setCategory(category);
        setTokenId(token_id);

        let payload = { category };

        if (account_no && account_no !== "") {
          payload.client_code = account_no;
        } else if (token_id && token_id !== "") {
          payload.token_id = token_id;
        }

        let response = await axios.post(CONSTANT.BASE_URL + 'api/Builder/get-client-layer-details',payload);
        if(token_id && token_id !== ""){
          setClientCode(response?.data?.client_id[0]?.account_no);
        }
        setGlobalClientDetails(response?.data);
        setAccessToken(response?.data?.client_id[0]?.access_token);

        // Convert flag JSON into key => value pairs
        let flag_array = {};
        try {
          let flagData = response?.data?.client_id[0]?.flags;
          if (typeof flagData === 'string' && flagData !== '') {
            flagData = JSON.parse(flagData);
          }
          if (flagData && typeof flagData === 'object') {
            for (const [key, value] of Object.entries(flagData)) {
              flag_array[key] = value;
            }
          }
        } catch (error) {
          console.error('Error parsing client flag JSON:', error);
        }
        setFlags(flag_array);

        // 🔑 Set token in header (as plain string)
        axios.defaults.headers.post['Authorization'] = response?.data?.client_id[0]?.access_token;

        // // Inject retailer theme CSS if available
        // const themeCssUrl = response?.data?.theme_css_url;
        // if (themeCssUrl) {
        //   const existing = document.getElementById('srb-theme-css');
        //   if (existing) {
        //     existing.href = themeCssUrl;
        //   } else {
        //     const link = document.createElement('link');
        //     link.id = 'srb-theme-css';
        //     link.rel = 'stylesheet';
        //     link.href = themeCssUrl;
        //     document.head.appendChild(link);
        //   }
        // }

        let filter_array = {};
        response?.data?.filter_option?.forEach((data, key) => {
          filter_array[data?.filter_code] = data;
        });
        if(response?.data?.estrella){
          for (const [key, value] of Object.entries(CONSTANT.FILTER_OPTION_ESTRELLA)) {
            if(!filter_array.hasOwnProperty(key)){
              filter_array[key] = value;
            }
          }
          setEsterllaFlag(response?.data?.estrella);
        }else{
          for (const [key, value] of Object.entries(CONSTANT.FILTER_OPTION)) {
            if(!filter_array.hasOwnProperty(key)){
              filter_array[key] = value;
            }
          }
        }
        setFilterOption(filter_array);
      } catch (error) {
        console.error('Error fetching client details:', error);
        setGlobalClientDetails(null); // Default if API fails
      } finally {
        setLoading(false);
      }
    };

    fetchClientDetails();
    fetchIPAddress();
  }, []);

  useEffect(() => {
    // Ensure window.MyApp exists
    if (!window.MyApp) {
      window.MyApp = {};
    }
    // Add removeFromBasket function to window.MyApp with parameters
    window.MyApp.removeFromBasket = (productCode) => {
      if (!productCode) {
        console.error("Product code is required to remove an item from the basket.");
        return;
      }
      removeFromBasket(productCode);
    };
    // Add other functions or variables as needed
    window.MyApp.fetchBasket = () => basketShopify; // Example of exposing the basket state
    // Clean up to avoid memory leaks
    return () => {
      delete window.MyApp.removeFromBasket;
      delete window.MyApp.fetchBasket; // Clean up other added variables or functions
    };
  }, [basketShopify]);

  const addToBasket = (item) => {
    // Check if CuitemDetails is not empty (add your specific condition here)
    if (item?.itemDetails && Object.keys(item?.itemDetails).length > 0) {
        setBasket((prev) => {
            const updatedBasket = { ...prev };  // Create a shallow copy of the basket object
            if (updatedBasket[item?.itemDetails?.product_code]) {
                // If the item exists, update the existing item (you can customize what to update here)
                updatedBasket[item?.itemDetails?.product_code] = { ...updatedBasket[item?.itemDetails?.product_code], ...item };
            } else {
                // If the item doesn't exist, add it to the basket
                updatedBasket[item?.itemDetails?.product_code] = { ...item };  // Adding the item with its details
            }
            // Save the updated basket to cookies
            Cookies.set('basket', JSON.stringify(updatedBasket), { expires: 7 });

            return updatedBasket;
        });
        setBasketShopify(() => {
          let updateShopifyBasket = {};
          if (updateShopifyBasket[item?.itemDetails?.product_code]) {
              // If the item exists, update the existing item (you can customize what to update here)
              updateShopifyBasket[item?.itemDetails?.product_code] = { ...updateShopifyBasket[item?.itemDetails?.product_code], ...item };
          } else {
              // If the item doesn't exist, add it to the basket
              updateShopifyBasket[item?.itemDetails?.product_code] = { ...item };  // Adding the item with its details
          }
          // Save the updated basket to cookies
          Cookies.set('basket', JSON.stringify(updateShopifyBasket), { expires: 7 });
          console.log("Updated the shopify basket");
          return updateShopifyBasket;
        });
    } else {
        console.log("CuitemDetails is empty, item not added to basket.");
    }
  };

  const removeFromBasket = (productCode) => {
    setBasket((prev) => {
      // Ensure prev is an object
      if (typeof prev !== 'object' || Array.isArray(prev) || prev === null) {
        console.error("Basket state is not an object. Resetting to an empty object.");
        return {}; // Reset to an empty object if it's not in the correct format
      }
  
      // Create a shallow copy of the basket
      const updatedBasket = { ...prev };
  
      // Remove the specific productCode
      if (productCode in updatedBasket) {
        delete updatedBasket[productCode];
      } else {
        console.warn(`Product code ${productCode} not found in the basket.`);
      }
  
      // Save the updated basket to cookies
      Cookies.set('basket', JSON.stringify(updatedBasket), { expires: 7 });
  
      return updatedBasket;
    });
  };
  

  return (
    <GlobalContext.Provider value={{ 
      golbalClientDetails, 
      basket, 
      loading, 
      accessToken,
      addToBasket, 
      removeFromBasket,
      layerparam,
      filterOption,
      updateLayerParams,
      layerItemIds, 
      updateLayerItemId, 
      client_code, 
      selectedItemId,
      updatedSelectedItemDetails,
      category,
      flags,
      esterllaFlag,
      builderType,
      setBuilderType }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
